<h3 mat-dialog-title>Confirmación</h3>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button (click)="closeDialog()">No</button>
    <button mat-button (click)="confirm()" cdkFocusInitial>Sí</button>
</div>